import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import calendar from './calendar'
import config from './config'
import logineoCalendar from '@/store/logineoCalendar'

Vue.use(Vuex)

export default new Vuex.Store(
  {
    state: {
      articles: [],
      article_pages: 0,
      total_articles: 0,
      warnings: [],
      navbar: [],
      latestEvents: [],
      dropdowns: [],
      sites: [],
      sections: [],
      quickaccess: [],
      key: '',
      currentMonth: 1,
      currentYear: 1
    },
    getters: {
      getStoredArticles: state => {
        return state.articles
      },
      getStoredArticleById: (state) => (id) => {
        const article = state.articles.find(article => article.id === id)
        if (article === undefined) {
          state.articles.push({ id: id })
          return state.articles.find(article => article.id === id)
        } else {
          return article
        }
      },
      getStoredArticlesByPage: (state) => (page = 1) => {
        if (isNaN(page)) {
          page = 1
        }
        return state.articles.filter(article => article.page === page)
      },
      getArticlePages: state => {
        return state.article_pages
      },
      getLatestArticles: (state, getters) => (amount = 5) => {
        return getters.getStoredArticlesByPage(state, 1).slice(0, amount)
      },
      getStoredWarnings: state => {
        return state.warnings
      },
      getStoredWarningById: state => id => {
        return state.warnings.find(warning => warning.id === id)
      },
      getStoredEvents: state => {
        return state.events
      },
      getStoredDropdowns: state => {
        return state.dropdowns
      },
      getStoredNavEntryByPosition: state => id => {
        id = parseInt(id)
        return state.navbar.find((element) => {
          return element.position === id
        })
      },
      getStoredSitesByDropdownId: state => id => {
        return state.sites.filter(element => element.dropdown_id === id)
      },
      getStoredSectionsBySiteId: state => id => {
        id = parseInt(id)
        return state.sections.filter(element => element.site_id === id)
      },
      getSectionById: state => id => {
        id = parseInt(id)
        return state.sections.find(element => element.id === id)
      },
      getStoredEventsByYearMonth: state => parameters => {
        const events = state.events.filter(element => {
          const currentStart = new Date(`${parameters.year}-${parameters.month}-01`)
          const currentEnd = new Date(`${parameters.year}-${parameters.month + 1}-01`)
          const start = new Date(element.start)
          const end = new Date(element.end)
          return start <= currentStart && end >= currentEnd
        })
        events.sort((a, b) => {
          const aD = new Date(a.start)
          const bD = new Date(b.start)
          return aD.getTime() - bD.getTime()
        })
        return events
      },
      getStoredLatestEvents: state => {
        return state.latestEvents
      },
      getLatestEventsById: state => id => {
        return state.latestEvents.find(element => element.id === id)
      },
      getStoredQuickAccess: state => {
        return state.quickaccess
      },
      getStoredQuickAccessById: state => id => {
        return state.quickaccess.find(element => element.id === id)
      },
      getStoredNavbar: state => {
        return state.navbar
      },
      getStoredSitesById: state => id => {
        return state.navbar.find((element) => element.type === 'staticSite' && element.id === id)
      },
      getStoredSiteById: state => id => {
        return state.sites.find((element) => element.id === id)
      },
      getArticleLastPage: state => {
        return state.article_pages
      },
      getTotalArticles: state => {
        return state.total_articles
      },
      getKey: state => {
        return state.key
      },
      getCurrentMonth (state) {
        return state.currentMonth
      },
      getCurrentYear (state) {
        return state.currentYear
      }
    },
    mutations,
    actions,
    modules: {
      calendar,
      config,
      logineoCalendar
    }
  }
)
